import { extent } from 'd3-array'
import { cloneDeep } from 'lodash'

import Span from 'live/services/span'

import { DataNavigationState } from 'plugin-live-exploratory-viz/src/data-navigation/types/widget'
import { getYPoint } from 'plugin-live-exploratory-viz/src/data-navigation/reducer/utils'
import { shouldDelayClearState } from 'plugin-live-exploratory-viz/src/data-navigation/reducer'

export function onSpanQuery(message: SpanFlowMessage, state: DataNavigationState): DataNavigationState {
    // nothing changed. skip it.
    if (state.span[0] === message.events.begin && state.span[1] === message.events.end) {
        return cloneDeep(state)
    }

    const series = cloneDeep(state.series)

    // re-calculate min-max to each channel
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const [mnemonic, channel] of Object.entries(series)) {
        // remove events out of span.
        if (channel.data.length > 0) {
            channel.data = Span.crop(channel.data, message.events.begin, message.events.end)

            // calculate new domain.
            const newDomain = extent(
                channel.data.filter(point => point[1] !== null),
                getYPoint
            )

            channel.domain = newDomain?.[0] !== undefined || newDomain?.[1] !== undefined ? newDomain : [0, 0]
        } else {
            channel.domain = [0, 0]
        }
    }

    return {
        config: state.config,
        realtime: state.realtime,
        series: series,
        span: [message.events.begin, message.events.end],
        shouldDelayClearState: shouldDelayClearState
    }
}
